module.exports = __webpack_public_path__ + "img/q1.0485230b.jpg";